// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2DaXh","card":"Cards_card__2n2d_","infected":"Cards_infected__3ICW1","recovered":"Cards_recovered__3ERyk","deaths":"Cards_deaths__31maR"};